import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-summer-sports-camp',
  templateUrl: './summer-sports-camp.component.html',
  styleUrls: ['./summer-sports-camp.component.scss']
})
export class SummerSportsCampComponent implements OnInit {

  campImages = [
    '/assets/img/quick-links/summer-sports/1 (1).jpg',
    '/assets/img/quick-links/summer-sports/1 (2).jpg',
    '/assets/img/quick-links/summer-sports/1 (3).jpg',
    '/assets/img/quick-links/summer-sports/1 (4).jpg',
    '/assets/img/quick-links/summer-sports/1 (5).jpg',
    '/assets/img/quick-links/summer-sports/1 (6).jpg',
    '/assets/img/quick-links/summer-sports/1 (7).jpg',
    '/assets/img/quick-links/summer-sports/1 (8).jpg',
    '/assets/img/quick-links/summer-sports/1 (9).jpg',
    '/assets/img/quick-links/summer-sports/1 (10).jpg',
    '/assets/img/quick-links/summer-sports/1 (11).jpg',
    '/assets/img/quick-links/summer-sports/1 (12).jpg',
    '/assets/img/quick-links/summer-sports/1 (13).jpg',
    '/assets/img/quick-links/summer-sports/1 (14).jpg',
    '/assets/img/quick-links/summer-sports/1 (15).jpg',
    '/assets/img/quick-links/summer-sports/1 (16).jpg',
    '/assets/img/quick-links/summer-sports/1 (17).jpg',
    '/assets/img/quick-links/summer-sports/1 (18).jpg',
    '/assets/img/quick-links/summer-sports/1 (19).jpg',
  ];

  constructor() { }

  ngOnInit(): void { }

}
